<!-- 
  工厂日历
  1. 通过获取排班计划，配置 Calender 中的插槽
     使得可以显示每天的计划
  2. 借用 jDatePicker.js 中的代码
     用来计算对应的农历日期以及相应的节气和节日
     如果需要增加和删除个别的节日，可以在 '@/utils/jDatePicker.js' 中修改公农历节日列表
 -->
<template>
  <div>
    <calender>
      <div slot-scope="slotProps">
        <p class="lunar-date">
          {{date2lunar(slotProps.date).IMonthCn}}
          {{date2lunar(slotProps.date).IDayCn}}
          <strong>{{date2lunar(slotProps.date).Term||''}}</strong>
          <strong v-for="(item, index) in date2lunar(slotProps.date).festival" :key="index">
            {{item}}
          </strong>
        </p>
        <p v-if="typeof plan(slotProps.date) === 'string'">{{plan(slotProps.date)}}</p>
        <p v-else-if="!(plan(slotProps.date) instanceof Array)">Error</p>
        <p v-else-if="plan(slotProps.date).length === 0">{{$t('calender.noPlan')}}</p>
        <ul v-else style="padding:0;">
          <li
            style="list-style-type:none;"
            v-for="(workItem, index) in plan(slotProps.date)"
            :key="index"
          >
            {{nameList[workItem.teamIndex]}} &nbsp;&nbsp;
            {{getTime(workItem.start)}} - {{getTime(workItem.end)}}
          </li>
        </ul>
      </div>
    </calender>
  </div>
</template>

<script>
import Calender from "@/views/master/shift/Calender";
import Schedule from "@/utils/Schedule";
import { mapState } from "vuex";
import {
  // str2date,
  timeStr2num,
  // num2timeStr,
  date2timeStr,
  formalizeDate
} from "@/utils/day";
import jDatePicker from "@/utils/jDatePicker";

export default {
  components: {
    Calender
  },
  data() {
    return {
      nameList: ["甲", "乙", "丙", "丁", "戊"]
    };
  },
  computed: {
    ...mapState("teamShift", ["entity"]),
    firstStartTime() {
      return this.entity.firstStartTime;
    },
    cycleCount() {
      return this.entity.cycleCount;
    },
    teamCount() {
      return this.entity.teamCount;
    },
    startDate() {
      return new Date(this.entity.startDate);
    },
    endDate() {
      return new Date(this.entity.endDate);
    },
    plan() {
      // 输入参数空值校验
      const checkTarget = [
        "firstStartTime",
        "cycleCount",
        "teamCount",
        "startDate",
        "endDate"
      ];
      for (let name of checkTarget) {
        if (this[name] === undefined) {
          return () =>
            this.$t("lbl.teamShift." + name) + this.$t("calender.error");
        }
      }

      let startDateWithTime = new Date();
      startDateWithTime.setTime(
        formalizeDate(this.startDate).getTime() +
          timeStr2num(this.firstStartTime) * 60 * 1000 // 分钟转毫秒 * 60000
      );
      /**
       * 这里返回一个函数
       * Calender 中将使用该函数生成指定日期的 html
       */
      return function(date) {
        return Schedule.getWorkItemList(
          formalizeDate(date),
          this.teamCount,
          this.cycleCount,
          startDateWithTime,
          this.endDate
        ); // 每日计划
      };
    }
  },
  methods: {
    getTime(date) {
      return date2timeStr(date);
    },
    /**
     * 返回日期对应的农历信息
     * @example
     * { "lYear": 2019, "lMonth": 9, "lDay": 10, "isFestival": false, "festival": [], "Animal": "猪", "IMonthCn": "九月", "IDayCn": "初十", "cYear": 2019, "cMonth": 10, "cDay": 8, "gzYear": "己亥", "gzMonth": "甲戌", "gzDay": "戊寅", "isToday": false, "isLeap": false, "nWeek": 2, "ncWeek": "星期二", "isTerm": true, "Term": "寒露", "astro": "天秤座" }
     * { "lYear": 2019, "lMonth": 9, "lDay": 9, "isFestival": true, "festival": [ "重阳" ], "Animal": "猪", "IMonthCn": "九月", "IDayCn": "初九", "cYear": 2019, "cMonth": 10, "cDay": 7, "gzYear": "己亥", "gzMonth": "癸酉", "gzDay": "丁丑", "isToday": false, "isLeap": false, "nWeek": 1, "ncWeek": "星期一", "isTerm": false, "Term": null, "astro": "天秤座" }
     */
    date2lunar(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return jDatePicker.calendar.solar2lunar(y, m, d);
    }
  }
};
</script>

<style scoped>
  strong{
    color:#e02d2d; 
  }
</style>